import React from 'react';

const LoveLetter = () => {
  return (
    <div className="px-6 pb-16 md:px-12 md:pb-24 animate-slide-up">
      {/* Decorative Line */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-christmas-red to-transparent mb-12"></div>
      
      {/* Letter Content */}
      <div className="max-w-2xl mx-auto">
        {/* Salutation */}
        <p className="font-serif text-xl md:text-2xl mb-8 tracking-wide text-christmas-red">
          Dear Aadhya (no middle name) Deshmukh,
        </p>

        {/* Letter Body */}
        <div className="space-y-6 font-sans text-sm md:text-base leading-relaxed text-gray-800">
          <p>
            To know you is to love you—and to love you is to learn from you. From the history of fashion houses, to the proper strategy for making sunny-side up eggs, to all the creative ways that adults can use toys together: you take me back to school everyday. You're wise beyond your years, except when it comes to the dangers of protein powder :) and you truly know how to grab life by the balls. I'm addicted to your playfulness, inspired by your passion for your work, and hopelessly adore the way you carry yourself each and every day. Through missed bus stops, failed trekking expeditions, and even solo hospital trips, your light burns bright and refuses to be extinguished. Perhaps it's the city life that has made you this strong or like Thor's Hammer your powers were forged in the heart of a dying star. I can only hope you never learn how to harness this internal resolve and use it for extra strength in our thumb-wars and arm wrestles, because then I'll be in real trouble.
          </p>

          <p>
            This week I realized just how much the world has changed since we first met, and how we've changed along with it. As you know, I do just as much fearing as I do dreaming about the future, and this little love of ours has done nothing but intensify that affliction. Like Andy's words in the final episode of The Office, I question if this time with you is my version of "the good old days" and if I'll know when that last old day comes. But looking through these photos I realize that the whole point is to not know. It's to make so many memories with your person that you never have time to actually remember them. It's to live everyday like it could be the last old day, but wake up each morning young and prepared for a million more. Because someday we will hit our last TMPL workout, open our final bottle of wine, and you'll even beat me in pool. But today is not that day, and for that I am forever grateful.
          </p>
        </div>

        {/* Signature */}
        <div className="mt-12 text-right text-christmas-green">
          <p className="font-serif text-lg md:text-xl italic mb-2">
            All yours,
          </p>
          <p className="font-serif text-2xl md:text-3xl tracking-wide">
            Luke
          </p>
        </div>

        {/* Decorative Bottom Line */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-christmas-green to-transparent mt-12"></div>
        
        {/* Footer Message */}
        <div className="text-center mt-8 text-xs text-gray-500 tracking-widest uppercase">
          Christmas 2025
        </div>
      </div>
    </div>
  );
};

export default LoveLetter;
